import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Button,
  MenuItem,
} from '@material-ui/core';
import * as strings from '../../helpers/strings';

import Page from '../../common-components/Page';
import { getUserId, getFastDataStationId } from '../../helpers/common';

import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as downloadConfigReducers from '../reducer/DownloadConfigSelectReducers';
import * as downloadConfigActionMgr from '../action-mgr/DownloadConfigSelectActionMgr';


class DownloadConfigSelect extends Component {
  constructor() {
    super();
    this.handleStationChange = this.handleStationChange.bind(this);
    // this.handleDownloadConfigSubmit =  this.handleDownloadConfigSubmit.bind(this);
    this.handleReset =  this.handleReset.bind(this);
    this.state = {
      selectedStationName: '',
      isResetButtonDisabled: true,
    };
  }

  componentDidMount = () => {
    const { stations, setSelectedStationName, currentStationName} = this.props;

    if (stations.length > 0) {
      const selectedStation = stations.find(station => station.id === getFastDataStationId());
      const stationName = currentStationName || (selectedStation ? selectedStation.name : stations[stations.length - 1].name);
      setSelectedStationName(stationName);
    }
  }

  handleStationChange = (event) => {
    const { setSelectedStationName, setCurrentDownloadConfigStation, clearSelectedFiles } = this.props;
    const selectedStationName = event.target.value;
    setSelectedStationName(selectedStationName);
    setCurrentDownloadConfigStation(selectedStationName)

    clearSelectedFiles();
  };
  
  handleDownloadConfigSubmit = () => {
    const { selectedStationName, listDownloadConfigObject } = this.props;
  
    // Create the request data object with "userId" and "stationName"
    const requestdata = {
      "userId": getUserId(),
      "stationName": selectedStationName
    };
    listDownloadConfigObject(requestdata);
  };

  handleReset = () => {
    // Reset the selected values to their initial states
    this.setState({
      selectedStationName: '',
      isResetButtonDisabled: true,
      checkedItems: {}, 
    });
    this.props.clearSelectedFiles();
  };

  render() {
    const {
      stations,
      selectedStationName, 
      currentStationName
      } = this.props;
    const currentConfigStationName = currentStationName || selectedStationName;
    const sortStations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1)

    return (
      <Paper>
        <Page title={strings.lblDownload}>
          <Grid container spacing={16}>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectStation}>
                  {strings.lblStation}
                </InputLabel>
                <Select
                  value={currentConfigStationName}
                  onChange={this.handleStationChange}
                  input={
                    <OutlinedInput
                      labelWidth={60}
                      name={strings.lblStations}
                      id={strings.idSelectStation}
                    />
                  }
                >
                 {sortStations.map(station => (
                    <MenuItem key={station.id} value={station.name}>
                      {station.name} - {station.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>  
            <Grid item md={10} sm={6} xs={12}>
            </Grid>
          </Grid>
          <br />
            <div className='ReportButtonDiv'>
              {/*  Submit button */}
              <Button
                variant={strings.btnRaised}
                color={strings.colorPrimary}
                onClick={this.handleDownloadConfigSubmit}
                disabled={
                  !selectedStationName
                }
              >
                {strings.lblSubmit}
              </Button>
              <Button
                  variant={strings.btnRaised}
                  color={strings.colorPrimary}
                  onClick={this.handleReset}
                  disabled={this.state.isResetButtonDisabled}
                >
                  {strings.lblReset}
              </Button>
            </div>
        </Page>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  selectedStationName: downloadConfigReducers.getSelectedStationName(state),
  currentStationName: downloadConfigReducers.getCurrentDownloadConfigStation(state),
  downloadConfigListObject: downloadConfigReducers.listDownloadConfigObject(state)
});

const mapActionsToProps = {
  setSelectedStationName: downloadConfigActionMgr.setSelectedStationName,
  setCurrentDownloadConfigStation: downloadConfigActionMgr.setCurrentDownloadConfigStation,
  clearSelectedFiles: downloadConfigActionMgr.clearSelectedFiles,
  listDownloadConfigObject: downloadConfigActionMgr.callListDownloaConfigObjectApi
}

export default connect(mapStateToProps, mapActionsToProps)(
 (DownloadConfigSelect)
)